module.exports = __webpack_public_path__ + "static/media/thomas-avatar.a8525b67.svg";